module.exports = __webpack_public_path__ + "img/afam-color.b2be479.png";